// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bzZN","newExpiryDate":"styles_newExpiryDate__2l8T_","footer":"styles_footer__b8fUA"};